import api from "../util/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";
import { toastError, toastSucess } from "../util/toast";
import { setModalCadastrarContatoPessoa, setModalDeletarContatoPessoa } from "../redux/slices/contatoPessoa/contatoPessoaSlice";

export const cadastrarContatoPessoa = createAsyncThunk("/ContatoPessoa/CadastrarContatoPessoa", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/ContatoPessoa/CadastrarContatoPessoa", payload.value);
    toastSucess("Contato cadastrado com sucesso");
    dispatch(setModalCadastrarContatoPessoa(false));
    dispatch(setLoading(false));

    dispatch(buscarContatoPessoa(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const buscarContatoPessoa = createAsyncThunk("/ContatoPessoa/BuscarContatoPessoa", async (idPessoa: number) => {
  try {
    const data = await api.get("/ContatoPessoa/BuscarContatoPessoa", {
      params: { idPessoa: idPessoa },
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const listarTipoContatoPessoa = createAsyncThunk("/ContatoPessoa/ListarTipoContatoPessoa", async () => {
  try {
    const data = await api.get("/ContatoPessoa/ListarTipoContatoPessoa");
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const atualizarContatoPessoa = createAsyncThunk("/ContatoPessoa/AtualizarContatoPessoa", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/ContatoPessoa/AtualizarContatoPessoa/", payload.value);
    toastSucess("Contato atualizado com sucesso");
    dispatch(setModalCadastrarContatoPessoa(false));
    dispatch(setLoading(false));

    dispatch(buscarContatoPessoa(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const atualizarContatoPessoaAtivo = createAsyncThunk("/ContatoPessoa/AtualizarContatoPessoaAtivo", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/ContatoPessoa/AtualizarContatoPessoaAtivo", null, { params: payload.value });
    toastSucess("Status de ativo do contato foi atualizado com sucesso");
    dispatch(setLoading(false));

    dispatch(buscarContatoPessoa(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const deletarContatoPessoa = createAsyncThunk("/ContatoPessoa/DeletarContatoPessoa", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.delete("/ContatoPessoa/DeletarContatoPessoa", {
      params: { id: payload.value },
    });
    toastSucess("Contato removido com sucesso");
    dispatch(setModalDeletarContatoPessoa(false));
    dispatch(setLoading(false));

    dispatch(buscarContatoPessoa(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});
